import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';

class FormSection extends Component {
  render() {
    let titleElm = this.props.title ? <h4>{this.props.title}</h4> : '';
    let marginTop = this.props.marginTop ? this.props.marginTop : 'inherit';
    // let marginTop = this.props.marginTop;
    
    const headingStyle = {
      marginTop: marginTop
    };

    return (
      <Row className={'formSection'}>
        <Col xs={12} style={headingStyle}>{titleElm}</Col>
        {this.props.fields}
      </Row>
    );
  }
}

export default FormSection;



// WEBPACK FOOTER //
// ./src/components/FormSection.js